import React from 'react';
import { PageTrackerWrapper } from 'queries/user/track';
import LockedPage from 'components/LockPage/Loadable';
import TrombiData from 'containers/Trombinoscope/Trombi/Loadable';
import { screenshotUrls } from 'containers/screenshotUrls';
import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import { Outlet } from 'react-router-dom';

export const TrombinoscopeRoutes = {
  path: 'trombinoscope',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.eleves.trombinoscope" />
      <Outlet />
    </>
  ),
  children: [
    {
      path: 'locked',
      element: (
        <PageTrackerWrapper title="Trombinoscope - nope">
          <LockedPage
            featureKey="trombinoscope"
            s3ImagePath={screenshotUrls.trombinoscope}
          />
        </PageTrackerWrapper>
      ),
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="Trombinoscope">
          <TrombiData />
        </PageTrackerWrapper>
      ),
    },
  ],
};
